import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Parser from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import * as Sentry from "@sentry/react";
import WithdrawalActionConfirmation from "./WithdrawalActionConfirmation";
import Button from "../../../../shared/button/Button";
import Sending from "../../../../shared/loaders/Sending";
import ModalThankYou from "../../../../shared/loaders/ModalThankYou";
import {
  Form,
  Label,
  Field,
  TextInput,
  ButtonsWrapper,
  FileInputLabel,
  FileInput,
  Filename,
  RemoveAttachment,
  Error,
} from "../styles/withdraw-candidate-styles";

class Confirm extends Component {
  constructor(props) {
    super(props);
    this.attachmentRef = React.createRef();
    const { cardData } = this.props;
    const { status } = cardData;

    this.state = {
      formLoading: false,
      successMessageActive: false,
      actionConfirmationActive: status === "offered",
      message: "",
      attachment: "",
      fileAttached: false,
      errors: null,
    };
  }

  showSuccessMessage = () => {
    this.setState({ successMessageActive: true });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });
    const { message, attachment } = this.state;
    const { cardData, closeActionModalAfterSubmit, fetchKanbanData } =
      this.props;
    const { updateStatusLink } = cardData;
    const url = updateStatusLink;

    const formData = new FormData();

    formData.append("application_action[action]", "rejected_candidate");
    formData.append("application_action[message]", message);
    formData.append("application_action[attachment]", attachment);
    formData.append("application_action[action_at]", Date.now());

    const payload = {
      url,
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    };

    axios(payload)
      .then(() => {
        this.setState({ formLoading: false, errors: null });
        this.showSuccessMessage();
        setTimeout(() => {
          closeActionModalAfterSubmit();
          fetchKanbanData({ loading: false, updating: true });
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data.errors,
          formLoading: false,
        });
        Sentry.captureException(err);
      });
  };

  handleMessage = (e) => {
    this.setState({ message: e.target.value });
  };

  handleAttachment = (e) => {
    this.setState({ attachment: e.target.files[0], fileAttached: true });
  };

  removeAttachment = () => {
    const node = this.attachmentRef.current;

    this.setState({ attachment: "", fileAttached: false });
    node.value = null;
  };

  handleActionConfirmation = (e) => {
    e.preventDefault();
    this.setState({
      actionConfirmationActive: false,
    });
  };

  handleCancel = (e) => {
    e.preventDefault();
    const { closeActionModalAfterReset } = this.props;
    this.setState({ message: "", errors: null });
    closeActionModalAfterReset();
  };

  render() {
    const {
      errors,
      message,
      fileAttached,
      successMessageActive,
      formLoading,
      actionConfirmationActive,
    } = this.state;
    const { candidate } = this.props;

    return (
      <Fragment>
        {actionConfirmationActive && (
          <WithdrawalActionConfirmation
            handleCancel={this.handleCancel}
            handleActionConfirmation={this.handleActionConfirmation}
          />
        )}
        {formLoading && <Sending white />}
        {successMessageActive && (
          <ModalThankYou text="Candidate withdrawn successfully" />
        )}
        <Form onSubmit={this.handleSubmit}>
          <Label className="animated fadeInUp delay-1">
            You&apos;re about to <strong>withdraw</strong>{" "}
            <strong>{candidate}</strong>. <br /> Please let the employer know
            why you&apos;re withdrawing your candidate.
          </Label>
          <Field className="animated fadeInUp delay-3">
            <TextInput
              value={message}
              placeholder="Please add your message..."
              onChange={this.handleMessage}
            />
            {errors && errors.message && (
              <Error className="animated bounceIn">
                Message can&apos;t be blank when withdrawing a candidate.
              </Error>
            )}
          </Field>
          <Field className="animated fadeInUp delay-4">
            <FileInputLabel htmlFor="file" fileAttached={fileAttached}>
              <FontAwesomeIcon icon={faPaperclip} />
            </FileInputLabel>
            <FileInput
              type="file"
              name="file"
              id="file"
              ref={this.attachmentRef}
              onChange={this.handleAttachment}
            />
            <Filename>
              {fileAttached
                ? `${this.attachmentRef.current.files[0].name.replace(
                    "C:\\fakepath\\",
                    ""
                  )}`
                : Parser("Attach a file <span>(optional)</span>")}
            </Filename>
            {fileAttached && (
              <Fragment>
                <ReactTooltip
                  html
                  place="left"
                  type="dark"
                  effect="solid"
                  aria-haspopup="true"
                  id="remove-attachment-tooltip"
                />
                <RemoveAttachment
                  onClick={this.removeAttachment}
                  data-tip="Remove this attachment"
                  data-for="remove-attachment-tooltip"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </RemoveAttachment>
              </Fragment>
            )}
          </Field>
          <ButtonsWrapper className="animated fadeInUp delay-4">
            <Button
              secondary
              buttonName="Cancel"
              onClickAction={this.handleCancel}
            />
            <Button primary buttonName="Withdraw Candidate" type="submit" />
          </ButtonsWrapper>
        </Form>
      </Fragment>
    );
  }
}

Confirm.propTypes = {
  candidate: PropTypes.string.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    updateStatusLink: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
  closeActionModalAfterReset: PropTypes.func.isRequired,
};

export default Confirm;
